import { type ReactElement } from "react";
import type { ParetoParams } from "@playbookai/widget-schemas";
import type { WidgetBodyProps } from "../types.js";
import { ParetoBody } from "../paretoL1/Component.js";

export function ParetoL2Widget({
  data,
}: WidgetBodyProps<ParetoParams>): ReactElement {
  return <ParetoBody data={data} accent="cyan" />;
}
